import { render, staticRenderFns } from "./pressDifAlarmDetail.vue?vue&type=template&id=5ebbc710&scoped=true"
import script from "./pressDifAlarmDetail.vue?vue&type=script&lang=js"
export * from "./pressDifAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./pressDifAlarmDetail.vue?vue&type=style&index=0&id=5ebbc710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbc710",
  null
  
)

export default component.exports